import { Dialog } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  QueryList,
  ViewChildren
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { TippyDirective } from '@ngneat/helipopper';
import { filter } from 'rxjs';

import { BuffsContainerComponent } from '@app/modules/buffs-active';
import { PaymentSection, PaymentTabs } from '@app/modules/payment/payment.entity';
import { PaymentState } from '@app/modules/payment/payment.state';
import { AuthState } from '@app/modules/users';
import { LevelColorPipe, UserAvatarPipe, UserPictureColor } from '@app/modules/users/pipes';
import { MediaQueryService } from '@core/breakpoints';
import { ConvertDirective } from '@core/converter';
import { WebsocketClient } from '@core/websocket';
import { LoginButtonComponent } from '@ui/components/login-button';

import { ContainerComponent } from '../../../modules/notifications';
import { SettingsDialog } from '../../dialogs/settings/settings.dialog';
import { HeaderBurgerMenuComponent } from '../header-burger-menu/header-burger-menu.component';
import { WagerBonusComponent } from '../wager-bonus/wager-bonus.component';

@Component({
  selector: 'shell-header',
  templateUrl: './header.component.html',
  styleUrl: './styles/index.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    LoginButtonComponent,
    ConvertDirective,
    NgClass,
    ContainerComponent,
    HeaderBurgerMenuComponent,
    LevelColorPipe,
    UserAvatarPipe,
    UserPictureColor,
    WagerBonusComponent,
    BuffsContainerComponent
  ]
})
export class HeaderComponent {
  public readonly authState = inject(AuthState);
  public readonly paymentState = inject(PaymentState);

  private readonly router = inject(Router);
  private readonly dialog = inject(Dialog);
  private readonly destroyRef = inject(DestroyRef);
  public readonly websocketClient = inject(WebsocketClient);

  @ViewChildren(TippyDirective)
  private readonly tippyRefs?: QueryList<TippyDirective>;

  private readonly mediaService = inject(MediaQueryService);

  public isLg = toSignal(this.mediaService.mediaQuery('max', 'lg'));

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.tippyRefs && this.tippyRefs.forEach((tippyRef) => tippyRef.hide());
      });
  }

  logout(): void {
    this.authState.logout();
  }

  openSettingsDialog(): void {
    this.dialog.open(SettingsDialog);
  }

  navigateToPayment(isWithdrawal = false): void {
    const targetSection = isWithdrawal ? PaymentSection.WITHDRAWAL : PaymentSection.DEPOSIT;
    const targetTab = isWithdrawal ? PaymentTabs.STEAM : PaymentTabs.DEFAULT;

    this.paymentState.currentSection.set(targetSection);
    this.paymentState.currentTab.set(targetTab);

    this.router.navigate(['/payment']);
  }

  public temporaryBanner = false;
}
